var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFurniture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480,220H300V10c0-5.522-4.477-10-10-10H10C4.477,0,0,4.478,0,10v470c0,5.522,4.477,10,10,10h265c5.523,0,10-4.478,10-10 v-30h120v30c0,5.522,4.477,10,10,10h35c5.523,0,10-4.478,10-10v-30h5c5.523,0,10-4.478,10-10V275h5c5.523,0,10-4.478,10-10v-35 C490,224.478,485.523,220,480,220z M140,470H20v-85h120V470z M140,365H20V20h120V365z M230,470h-70V20h120v200h-75 c-5.523,0-10,4.478-10,10v35c0,5.522,4.477,10,10,10h10v165c0,5.522,4.477,10,10,10h5V470z M265,470h-15v-20h15V470z M440,470 h-15v-20h15V470z M455,430H235v-70h220V430z M455,340H235v-65h220V340z M470,255H215v-15h255V255z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 295,
    width: 30,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 380,
    width: 30,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 160,
    width: 20,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 160,
    width: 20,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 415,
    width: 30,
    height: 20
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture);
export default __webpack_public_path__ + "static/media/furniture.e7f3080d77440d48554d2ccd941cf20a.svg";
export { ForwardRef as ReactComponent };